import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster 
      position="top-right" 
      toastOptions={{
        style: {
          background: '#1a1a1a',
          border: '1px solid rgba(212, 175, 55, 0.3)',
          color: '#e5e5e5',
        },
      }}
    />
  </React.StrictMode>,
);
